import React from 'react';
import PropTypes from 'prop-types';
import Footer from 'cccisd-footer';
import Banner from 'js/components/Banner';
import Header from 'js/components/Header';
import style from './style.css';

export default class MainFixedLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        showPrimaryNav: PropTypes.bool,
        showFooter: PropTypes.bool,
        bannerType: PropTypes.string,
    };

    static defaultProps = {
        className: 'container',
        showPrimaryNav: true,
        showFooter: true,
    };

    render() {
        return (
            <div className={style.wrapper}>
                {this.props.showPrimaryNav && <Header className={this.props.className} />}
                {this.props.bannerType && <Banner bannerType={this.props.bannerType} />}

                <div className={style.body}>
                    <div className={this.props.className}>{this.props.children}</div>
                </div>

                {this.props.showFooter && (
                    <div className={style.footer}>
                        <Footer className={this.props.className} />
                    </div>
                )}
            </div>
        );
    }
}
